<template>
	<div>
		<v-select :items="surveys" v-model="selected" multiple item-text="title" item-value="id" chips deletable-chips>
		</v-select>
		<p class="text-right">
			<v-btn color="primary2" fab dark @click="save"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
		</p>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "AddSectionsToPart", 
		props: {
			part: {type: Object}
		},
		data: () => {
			return {
				selected: []
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				surveys: state => state.surveys
			})
		},
		methods: {
			save(){
				const self = this;
				self.selected.forEach( s => {
					var section = {
						id: self.generateId(),
						survey: s,
						name: self.surveys.find( a => a.id == s ).title,
					}
					if( !self.part.sections ){
						self.part.sections = [];
					}
					self.$store.dispatch( "assessmentSettings/addSectionToPart", {part_id: self.part.id , section: section} );
				})
				self.$emit("close")
				self.selected = []
			}
		}
		// created(){
			
		// }

	}
</script>